module.exports = __webpack_public_path__ + "static/theme-section-graphic-74c312727e6b2cb469b938f43cf19518.jpg";